export default __webpack_public_path__ + "static/media/doctor-6.75c411d2.jpg";